var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('RouterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }